import {
  ByteString2qc03wzjsovk as ByteString,
  Companion_getInstance2g1g1maz1t653 as Companion_getInstance,
} from './ByteString.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount,
  arrayRangeEquals1k0armei4gb4e as arrayRangeEquals,
} from './Util.mjs';
import { segment35wobhh99hrhg as segment } from './internal/SegmentedByteString.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Segmentnhwb43ukbiy3 as Segment } from './Segment.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function toByteString($this) {
  return new (ByteString())($this.f3x());
}
var SegmentedByteStringClass;
function SegmentedByteString() {
  if (SegmentedByteStringClass === VOID) {
    class $ extends ByteString() {
      constructor(segments, directory) {
        super(Companion_getInstance().w3w_1.d3v_1);
        this.u3w_1 = segments;
        this.v3w_1 = directory;
      }
      c3x() {
        return toByteString(this).c3x();
      }
      d3x(pos) {
        // Inline function 'okio.internal.commonInternalGet' call
        checkOffsetAndCount(fromInt(this.v3w_1[this.u3w_1.length - 1 | 0]), fromInt(pos), 1n);
        var segment_0 = segment(this, pos);
        var segmentOffset = segment_0 === 0 ? 0 : this.v3w_1[segment_0 - 1 | 0];
        var segmentPos = this.v3w_1[segment_0 + this.u3w_1.length | 0];
        return this.u3w_1[segment_0][(pos - segmentOffset | 0) + segmentPos | 0];
      }
      e3x() {
        // Inline function 'okio.internal.commonGetSize' call
        return this.v3w_1[this.u3w_1.length - 1 | 0];
      }
      f3x() {
        // Inline function 'okio.internal.commonToByteArray' call
        var result = new Int8Array(this.q2());
        var resultPos = 0;
        // Inline function 'okio.internal.forEachSegment' call
        var segmentCount = this.u3w_1.length;
        var s = 0;
        var pos = 0;
        while (s < segmentCount) {
          var segmentPos = this.v3w_1[segmentCount + s | 0];
          var nextSegmentOffset = this.v3w_1[s];
          var tmp0 = this.u3w_1[s];
          var byteCount = nextSegmentOffset - pos | 0;
          var tmp4 = resultPos;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = segmentPos + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, result, tmp4, segmentPos, endIndex);
          resultPos = resultPos + byteCount | 0;
          pos = nextSegmentOffset;
          s = s + 1 | 0;
        }
        return result;
      }
      g3x(buffer, offset, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        var endIndex = offset + byteCount | 0;
        var s = segment(this, offset);
        var pos = offset;
        while (pos < endIndex) {
          var segmentOffset = s === 0 ? 0 : this.v3w_1[s - 1 | 0];
          var segmentSize = this.v3w_1[s] - segmentOffset | 0;
          var segmentPos = this.v3w_1[this.u3w_1.length + s | 0];
          // Inline function 'kotlin.comparisons.minOf' call
          var b = segmentOffset + segmentSize | 0;
          var byteCount_0 = Math.min(endIndex, b) - pos | 0;
          var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
          var data = this.u3w_1[s];
          var segment_0 = Segment().y3v(data, offset_0, offset_0 + byteCount_0 | 0, true, false);
          if (buffer.a3v_1 == null) {
            segment_0.w3v_1 = segment_0;
            segment_0.v3v_1 = segment_0.w3v_1;
            buffer.a3v_1 = segment_0.v3v_1;
          } else {
            ensureNotNull(ensureNotNull(buffer.a3v_1).w3v_1).b3w(segment_0);
          }
          pos = pos + byteCount_0 | 0;
          s = s + 1 | 0;
        }
        var tmp = buffer;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = buffer.b3v_1;
        tmp.b3v_1 = add(this_0, fromInt(byteCount));
        return Unit_instance;
      }
      h3x(offset, other, otherOffset, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRangeEquals' call
          if (offset < 0 || offset > (this.q2() - byteCount | 0)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var otherOffset_0 = otherOffset;
          var endIndex = offset + byteCount | 0;
          var s = segment(this, offset);
          var pos = offset;
          while (pos < endIndex) {
            var segmentOffset = s === 0 ? 0 : this.v3w_1[s - 1 | 0];
            var segmentSize = this.v3w_1[s] - segmentOffset | 0;
            var segmentPos = this.v3w_1[this.u3w_1.length + s | 0];
            // Inline function 'kotlin.comparisons.minOf' call
            var b = segmentOffset + segmentSize | 0;
            var byteCount_0 = Math.min(endIndex, b) - pos | 0;
            var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
            var data = this.u3w_1[s];
            if (!other.i3x(otherOffset_0, data, offset_0, byteCount_0)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
            pos = pos + byteCount_0 | 0;
            s = s + 1 | 0;
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      i3x(offset, other, otherOffset, byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonRangeEquals' call
          if (offset < 0 || offset > (this.q2() - byteCount | 0) || otherOffset < 0 || otherOffset > (other.length - byteCount | 0)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var otherOffset_0 = otherOffset;
          var endIndex = offset + byteCount | 0;
          var s = segment(this, offset);
          var pos = offset;
          while (pos < endIndex) {
            var segmentOffset = s === 0 ? 0 : this.v3w_1[s - 1 | 0];
            var segmentSize = this.v3w_1[s] - segmentOffset | 0;
            var segmentPos = this.v3w_1[this.u3w_1.length + s | 0];
            // Inline function 'kotlin.comparisons.minOf' call
            var b = segmentOffset + segmentSize | 0;
            var byteCount_0 = Math.min(endIndex, b) - pos | 0;
            var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
            var data = this.u3w_1[s];
            if (!arrayRangeEquals(data, offset_0, other, otherOffset_0, byteCount_0)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
            pos = pos + byteCount_0 | 0;
            s = s + 1 | 0;
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      b3x() {
        return this.f3x();
      }
      equals(other) {
        // Inline function 'okio.internal.commonEquals' call
        var tmp;
        if (other === this) {
          tmp = true;
        } else {
          if (other instanceof ByteString()) {
            tmp = (other.q2() === this.q2() && this.h3x(0, other, 0, this.q2()));
          } else {
            tmp = false;
          }
        }
        return tmp;
      }
      hashCode() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonHashCode' call
          var result = this.e3v_1;
          if (!(result === 0)) {
            tmp$ret$0 = result;
            break $l$block;
          }
          result = 1;
          // Inline function 'okio.internal.forEachSegment' call
          var segmentCount = this.u3w_1.length;
          var s = 0;
          var pos = 0;
          while (s < segmentCount) {
            var segmentPos = this.v3w_1[segmentCount + s | 0];
            var nextSegmentOffset = this.v3w_1[s];
            var tmp0 = this.u3w_1[s];
            var i = segmentPos;
            var limit = segmentPos + (nextSegmentOffset - pos | 0) | 0;
            while (i < limit) {
              result = imul(31, result) + tmp0[i] | 0;
              i = i + 1 | 0;
            }
            pos = nextSegmentOffset;
            s = s + 1 | 0;
          }
          this.z3w(result);
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      toString() {
        return toByteString(this).toString();
      }
    }
    initMetadataForClass($, 'SegmentedByteString');
    SegmentedByteStringClass = $;
  }
  return SegmentedByteStringClass;
}
//region block: exports
export {
  SegmentedByteString as SegmentedByteString5e5x58c4yl7l,
};
//endregion

//# sourceMappingURL=SegmentedByteString.mjs.map
